export default __webpack_public_path__ + "static/media/bg-Login.eca53aeb.png";